import { render } from "./MedicalHome.vue?vue&type=template&id=5b277c49&scoped=true"
import script from "./MedicalHome.vue?vue&type=script&lang=js"
export * from "./MedicalHome.vue?vue&type=script&lang=js"

import "./MedicalHome.vue?vue&type=style&index=0&id=5b277c49&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b277c49"]])

export default __exports__